export default __webpack_public_path__ + "static/media/Home1.dacd5c5d.png";